import React from 'react';
import { FvIconRadio } from '../../../../../ui/icon/FvIcons';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { OptionsTranslationSchema } from '../../translations/OptionsTranslationSchema';
import { createCommonFormSchema } from '../common/createCommonFormSchema';
import { ISingleSelectWidget } from './ISingleSelectWidget';
import {
  SingleSelectConfigComponent,
  singleSelectInputConfigValidator,
} from './SingleSelectConfigComponent';
import { SingleSelectWidgetComponent } from './SingleSelectWidgetComponent';
import { getSingleSelectWidgetSchema } from './SingleSelectWidgetSchema';
import { SingleSelectOption } from './component/SingleSelectOption';
import { getSingleSelectWidgetReference } from './getSingleSelectWidgetReference';

export const SingleSelectWidgetType: IWidgetType<ISingleSelectWidget> = {
  type: WidgetType.Select,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo scelta singola',
  icon: <FvIconRadio />,
  hasValue: true,
  getReference: getSingleSelectWidgetReference,
  formComponent: SingleSelectWidgetComponent,
  createFormSchema: ({ widget }) => {
    return createCommonFormSchema(getSingleSelectWidgetSchema(widget), widget);
  },
  previewComponent: SingleSelectWidgetComponent,
  optionComponent: SingleSelectOption,
  configValidator: singleSelectInputConfigValidator,
  configComponent: SingleSelectConfigComponent,
  translationSchema: tran.widget({
    ...InputCommonTranslationSchema.objectShape,
    options: OptionsTranslationSchema,
  }),
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [RequiredRule, CustomWarningsRule],
};
